<template>
  <div class="c-report-overview">
    <div class="overview-head">
      <div class="overview-head__num">01</div>
      <div class="overview-head__title">练习概览</div>
    </div>
    <ul class="overview-list">
      <li class="overview-list__item"  v-for="(item,index) in testOverviewlist"
      :class="item.bgClass"
      :key="`testItem_${index}`">
        <div class="item-status">
          {{item.title}}
        </div>
        <div class="item-num" >
         <!-- {{item.id!=2?item.num+'%':item.num+'道'}} -->
          {{item.num}}
        </div>
        <el-popover
          v-if="type===3"
          placement="bottom-start"
          popper-class="popover-top"
          width="320"
          offset
          trigger="hover"
          @after-enter="after"
          @show="show">
          <div class="item-link"  v-show="index==0" slot="reference">查看详细>></div>
          <el-tabs v-model="activeIndex" @tab-click="handleClick">
            <el-tab-pane :label="`已提交(${completedLen})`" name="one">
              {{completedToString?completedToString:'还没有学生提交，再等等吧～'}}
            </el-tab-pane>
            <el-tab-pane :label="`未提交(${incompleteLen})`" name="two">
              {{incompleteToString?incompleteToString:'很棒哦，全部学生都已经提交啦～'}}
            </el-tab-pane>
          </el-tabs>
        </el-popover>
      </li>
    </ul>
    <!--学生完成情况分布-->
    <practice-overview-student
      v-if="type!== 3"
      :maxLength="getMaxLength()"
      :spreadData="getStudentList()"/>
    <practice-overview-mt
      v-if="type === 3"
      :maxLength="getMaxLength()"
      :spreadData="getMtStudentList()" />
    <!-- 共同薄弱知识点 -->
    <practice-overview-point v-if="type!==3" :basicInfo="overviewInfo"/>
    <!-- mt试题柱形图 -->
    <topic-echarts
      v-if="type===3"
      @changeActiveName="changeActiveName"
      :topicList="overviewData.distribution" />
  </div>
</template>

<script>
import PracticeOverviewStudent from './practice-overview-student.vue';
import PracticeOverviewPoint from './practice-overview-point.vue';
import PracticeOverviewMt from './practice-overview-mt.vue';
import TopicEcharts from './topic-echarts.vue';

export default {
  name: 'reportOverview',
  components: {
    PracticeOverviewStudent, PracticeOverviewPoint, PracticeOverviewMt, TopicEcharts,
  },
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeIndex: 'one',
      classType: 1,
      overviewInfo: {},
      type: Number(this.$route.query.fromType),
      testOverviewlist: [
        {
          title: '完成情况', num: '', bgClass: 'list__complete', id: 0,
        },
        {
          title: '练习题目', num: '', bgClass: 'list__correct', id: 2,
        },
        {
          title: '最高/最低正答率', num: '', bgClass: 'list__average', id: 1,
        },
        {
          title: '平均正答率', num: '', bgClass: 'list__time', id: 3,
        },
      ],
    };
  },
  watch: {
    overviewData(v) {
      this.overviewInfo = v;
      this.initData();
    },
  },
  computed: {
    completedToString() {
      return this.overviewData.completed && this.overviewData.completed.map((item) => item.student_name).toString().replace(/,/g, '、');
    },
    incompleteToString() {
      return this.overviewData.in_process && this.overviewData.in_process.map((item) => item.student_name).toString().replace(/,/g, '、');
    },
    completedLen() {
      return this.overviewData.completed?.length;
    },
    incompleteLen() {
      return this.overviewData.in_process?.length;
    },
  },
  methods: {
    show() {
      this.activeIndex = '';
    },
    changeActiveName(val) {
      this.$emit('changeActiveName', val);
    },
    after() {
      this.activeIndex = 'one';
    },
    handleClick(tab) {
      this.activeIndex = tab.name;
    },
    getMtStudentList() {
      return this.overviewData.evaluate_id ? [
        {
          level: `优秀 [90, 100%] (${this.overviewData.completed.filter((item) => item.avg_right_rate > 0.9).length}人)`,
          stu_list: this.overviewData.completed.filter((item) => item.avg_right_rate > 0.9),
          type: 1,
          id: 1,
          total: this.overviewData.completed?.length,
          evaluate_id: this.overviewData.evaluate_id,
        },
        {
          level: `良好 [80, 90%] (${this.overviewData.completed.filter((item) => item.avg_right_rate > 0.8 && item.avg_right_rate <= 0.9).length}人)`,
          stu_list: this.overviewData.completed.filter(
            (item) => item.avg_right_rate > 0.8 && item.avg_right_rate <= 0.9,
          ),
          id: 2,
          type: 1,
          total: this.overviewData.completed?.length,
          evaluate_id: this.overviewData.evaluate_id,
        },
        {
          level: `合格 [60, 80%] (${this.overviewData.completed.filter((item) => item.avg_right_rate > 0.6 && item.avg_right_rate <= 0.8).length}人)`,
          stu_list: this.overviewData.completed.filter(
            (item) => item.avg_right_rate > 0.6 && item.avg_right_rate <= 0.8,
          ),
          type: 1,
          id: 3,
          total: this.overviewData.completed?.length,
          evaluate_id: this.overviewData.evaluate_id,
        },
        {
          level: `待关注[0, 60%] (${this.overviewData.completed.filter((item) => item.avg_right_rate <= 0.6).length}人)`,
          stu_list: this.overviewData.completed.filter((item) => item.avg_right_rate <= 0.6),
          type: 1,
          id: 4,
          total: this.overviewData.completed?.length,
          evaluate_id: this.overviewData.evaluate_id,
        },
      ] : [];
    },
    getStudentList() {
      // return this.overviewData.evaluate_id
      //   ? this.formatArr(1, this.overviewData.completed, 3).concat(
      //     this.formatArr(2, this.overviewData.in_process, 3),
      //   ) : [];
      return this.overviewData.evaluate_id ? [
        {
          level: `已完成 ${this.overviewData.completed?.length}`,
          stu_list: this.overviewData.completed.map((item) => item)
            .sort((a, b) => b.avg_right_rate - a.avg_right_rate),
          type: 1,
          evaluate_id: this.overviewData.evaluate_id,
        },
        {
          level: `进行中 ${this.overviewData.in_process?.length}`,
          stu_list: this.overviewData.in_process.map((item) => item)
            .sort((a, b) => b.avg_right_rate - a.avg_right_rate),
          type: 2,
          evaluate_id: this.overviewData.evaluate_id,
        },
      ] : [];
    },
    formatArr(type, array, num) {
      let index = 0;
      const arr = array.concat(array).concat(array);
      const newArray = [];
      while (index < arr.length) {
        newArray.push({
          arrType: type,
          level: type === 1 ? `已完成 ${array.length}` : `进行中 ${array.length}`,
          list: arr.slice(index, index += num),
        });
      }
      if (!array.length) {
        newArray.push({
          arrType: type,
          level: type === 1 ? `已完成 ${array.length}` : `进行中 ${array.length}`,
          list: [],
        });
      }
      return newArray;
    },
    getMaxLength() {
      return this.overviewData.evaluate_id
        ? Math.max(this.overviewData.completed.length, this.overviewData.in_process.length)
        : 0;
    },
    initData() {
      this.overviewInfo = this.overviewData;
      this.testOverviewlist.forEach((item, index) => {
        if (index === 0) {
          this.testOverviewlist[index].num = `${this.overviewInfo.finish_stu || 0}/${this.overviewInfo.total_stu || 0}`;
        }
        // if (index === 1) {
        //   this.testOverviewlist[index].num = Number(this.overviewInfo.avg_ability) === -1 ? '--'
        //     : this.overviewInfo.avg_ability;
        // }
        if (index === 1) {
          this.testOverviewlist[index].num = this.overviewInfo.questions_num ? `${this.overviewInfo.questions_num}道` : '--';
        }
        if (this.testOverviewlist.length > 3) {
          if (index === 2) {
            this.testOverviewlist[index].num = `${this.overviewInfo.max_right_rate ? (this.overviewInfo.max_right_rate * 100).toFixed(0) : 0}%/
            ${this.overviewInfo.min_right_rate ? (this.overviewInfo.min_right_rate * 100).toFixed(0) : 0}%`;
          }
          if (index === 3) {
            this.testOverviewlist[index].num = `${this.overviewInfo.avg_right_rate ? this.overviewInfo.avg_right_rate.toFixed(0) : 0}%`;
          }
        } else {
          this.testOverviewlist[2].num = `${this.overviewInfo.avg_right_rate ? this.overviewInfo.avg_right_rate.toFixed(0) : 0}%`;
        }
      });
    },
  },
  mounted() {
    this.initData();
    if (this.type !== 3) {
      this.testOverviewlist = this.testOverviewlist.filter((item) => item.id !== 1);
    }
  },

};
</script>

<style lang="scss">
.c-report-overview{
  padding-top:0.2rem;
  .overview-head{
    display: flex;
    padding-left:20px;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height: 29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .overview-list{
    display: flex;
    justify-content: center;
    margin:0.18rem 0.18rem 0 0;
    .list__complete{
      background-image: url('~@/views/pt/images/class_complete.png');
    }
    .list__average{
      background-image: url('~@/views/pt/images/class_average.png');
    }
    .list__correct{
      background-image: url('~@/views/pt/images/class_correct.png');
    }
    .list__time{
      background-image: url('~@/views/pt/images/report-answer.png');
    }
    &__item{
      // 兼容样式处理
      background-size:cover;
      width:2.76rem;
      height:1.52rem;
      margin-right: -.8vw;
      margin-left:-.35vw;
      .item-status{
        padding:0.33rem 0 0 0.4rem;
        font-size:0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        // margin-bottom:0.1rem;
      }
      .item-num{
        font-size:0.26rem;
        padding-left:2.8vw;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height:0.4rem;
        letter-spacing: 1px;
        // margin-bottom:0.1rem;
        &__total{
          font-size:0.22rem;
        }
      }
      .item-link{
        font-size:0.13rem;
        padding-left:0.4rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-decoration:underline;
        &:hover{
          cursor: pointer;
        }
      }
    }
  }

 }
 .detail-float{
   overflow: auto;
   .float-item{
    float: left;
    width: 50%;
    font-size:0.12rem;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
   }
 }

.el-popover.popover-top{
  margin-top:0.1rem;
}
</style>
